import { http } from "@common";
import endpoint from "../endpoint_cis";

export default {
    getTransferData: (data) => {
        return http.get(endpoint.transfer.get_data, data);
    },
    getRedirectUrl: (logicalName, proxyState, userName = '') => {
        return http.get(endpoint.transfer.get_redirect_uri.format(logicalName, proxyState, userName));
    },
    getRetrieveUrl: (logicalName, proxyState, from = '') => {
        return http.get(endpoint.transfer.get_retrieve_redirect.format(logicalName, proxyState, from));
    },
    regetProxyState: (proxyState) => {
        return http.patch(endpoint.transfer.get_proxystate.format(proxyState));
    },
    getQuickLinks: () => {
        return http.get(endpoint.transfer.get_quick_links);
    }
};